import Spinner from 'react-spinner-material'

export default function ButtonLoader() {
    return (
        <div>
        {/* <Spinner size={120} spinnerColor={"#333"} spinnerWidth={2} visible={true} /> */}
        <Spinner size={120} visible={true} />
      </div>
    )
}